import {UserLevelHistorySearchOption} from "../../search-option/user/UserLevelHistorySearchOption"

/**
 * 사용자 레벨 기록 검색, 계수 요청 URL 인자 구성 요소 설명
 */
export const UserLevelHistorySearchOptionDescription: Record<keyof UserLevelHistorySearchOption, string> = {
    idNeq: '기본키 불일치',
    idMin: '기본키 최소',
    idMax: '기본키 최대',
    userIdEq: '사용자 ID 일치',
    userIdNeq: '사용자 ID 불일치',
    userIdMin: '사용자 ID 최소',
    userIdMax: '사용자 ID 최대',
    userLevelIdEq: '사용자 레벨 ID 일치',
    userLevelIdNeq: '사용자 레벨 ID 불일치',
    userLevelIdMin: '사용자 레벨 ID 최소',
    userLevelIdMax: '사용자 레벨 ID 최대',
    assetLunarUsageIdEq: '루나 지급 ID 일치',
    assetLunarUsageIdNeq: '루나 지급 ID 불일치',
    assetLunarUsageIdMin: '루나 지급 ID 최소',
    assetLunarUsageIdMax: '루나 지급 ID 최대',
    assetLunarUsageIdIsNull: '루나 지급 ID 값 존재 여부',
    assetSolarUsageIdEq: '솔라 지급 ID 일치',
    assetSolarUsageIdNeq: '솔라 지급 ID 불일치',
    assetSolarUsageIdMin: '솔라 지급 ID 최소',
    assetSolarUsageIdMax: '솔라 지급 ID 최대',
    assetSolarUsageIdIsNull: '솔라 지급 ID 값 존재 여부',
    assetStarUsageIdEq: '스타 지급 ID 일치',
    assetStarUsageIdNeq: '스타 지급 ID 불일치',
    assetStarUsageIdMin: '스타 지급 ID 최소',
    assetStarUsageIdMax: '스타 지급 ID 최대',
    assetStarUsageIdIsNull: '스타 지급 ID 값 존재 여부',
    createdAtEq: '생성일 일치',
    createdAtNeq: '생성일 불일치',
    createdAtMin: '생성일 최소',
    createdAtMax: '생성일 최대',
}
